import React from "react";

const legalStyles = `
.legal-hero { background: linear-gradient(90deg,#0b5fa8 0%,#0d84d6 100%); color: #fff; padding: 18px 0; display:flex; align-items:center; justify-content:center; text-align:center; }
.legal-hero h1 { font-size: 1.5rem; margin: 0 0 6px; }
.legal-hero p { font-size: 1rem; margin: 0; opacity: 0.95; }
.legal-hero .legal-meta { margin-top: 8px; font-size: 12px; color: rgba(255,255,255,0.9); }
.legal-container { max-width: 820px; margin: 0 auto; padding: 20px 18px; }
.legal-card { background: #fff; border-radius: 8px; padding: 22px; box-shadow: 0 6px 24px rgba(12,22,38,0.06); }
.legal-card h2 { color: #0b5fa8; margin-bottom: 12px; font-size: 1.25rem; }
.legal-card h3 { color: #0f6fb2; margin-top: 14px; margin-bottom: 8px; }
.legal-card p { color: #374151; line-height: 1.7; margin-bottom: 12px; }
@media (max-width:640px) { .legal-hero { padding: 16px 0; } .legal-container { padding: 14px; } }
`;

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-roboto text-gray-800">
      <style>{legalStyles}</style>
      {/* Hero Section */}
      <div className="legal-hero">
        <div className="container mx-auto px-4">
          <h1>Privacy Policy</h1>
          <div className="legal-meta">Last updated: January 1, 2026</div>
        </div>
      </div>

      {/* Content */}
      <div className="legal-container">
        <div className="legal-card">
          <h2 className="text-3xl font-bold mb-4">Privacy Policy</h2>

          <section className="mb-8">
            <p className="mb-4 leading-relaxed">
              This "Privacy Policy" is released in accordance with, among other
              things, Rules 4 of the Information Technology (Reasonable Security
              Practices and Procedures and Sensitive Personal Data or
              Information) Rules, 2011 ("SPDI Rules"), Section 43A of the
              Information Technology Act, 2000 ("IT Act"), and Rule 3(1) of the
              Information Technology (Intermediaries Guidelines) Rules, 2011.
            </p>
            <p className="mb-4 leading-relaxed">
              This Privacy Policy describes how An Lextria Innovative Solutions
              ("Lextria Research" or the "Firm") collects, uses, maintains, and
              discloses certain personal information that may be collected from
              you when you use or access our website
              <strong> www.lextria.in</strong> ("Website").
            </p>
            <p className="leading-relaxed">
              By accepting the Privacy Policy and the Terms of Use, you
              expressly consent to our use and disclosure of your Personal
              Information in accordance with this Privacy Policy. If you do not
              agree to be bound by the terms of this Privacy Policy, please exit
              this page without accessing or using the Website or any of our
              services.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Your Privacy – Our Commitment
            </h3>
            <p className="leading-relaxed">
              We value the trust you place in us. We have designed our Privacy
              Policy to protect your Personal Information and keep it
              confidential. The privacy of our users is important to us, and we
              take all reasonable endeavors to prevent unauthorized disclosure
              of user information to third parties.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Personal Information
            </h3>
            <p className="mb-4 leading-relaxed">
              "Personal Information" means and includes all information that can
              be linked to a specific individual and/or entity or to identify
              any individual and/or entity, such as name, address, mailing
              address, telephone number, email address, and any details
              requested while using the Website. Personal Information includes
              all information received by us, whether via email, online forms,
              telephone, or other methods.
            </p>
            <p className="leading-relaxed">
              We store this information to improve our service level to you.
              However, we cannot guarantee the security of user information due
              to factors like unauthorized access, hardware/software failure, or
              other risks.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              General Information
            </h3>
            <p className="leading-relaxed">
              When you browse the Website, we may collect and record information
              such as your internet domain, IP address, and anonymous website
              statistics. By accepting this Privacy Policy, you consent to our
              use of cookies and other tracking technologies. You may configure
              your browser to disable cookies; however, this may limit some
              website functionalities.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Use of Personal Information
            </h3>
            <p className="mb-4 leading-relaxed">
              We may share your Personal Information as described in this
              Privacy Policy. We do not sell or rent Personal Information to
              third parties. The email address provided by you may be used for
              responding to inquiries, sending updates, newsletters, or other
              service-related information.
            </p>
            <p className="leading-relaxed">
              We take steps to protect against unauthorized access, use,
              alteration, disclosure, or destruction of Personal Information.
              However, we are not responsible for unauthorized access by third
              parties.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Disclosure of Information
            </h3>
            <p className="mb-4 leading-relaxed">
              Your information may be shared under specific circumstances, such
              as with trusted partners under confidentiality agreements, in
              response to legal requests, or to address illegal activities or
              threats.
            </p>
            <p className="leading-relaxed">
              We may also disclose information to government agencies for
              identity verification, crime prevention, or other legal
              requirements.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Changes to the Privacy Policy
            </h3>
            <p className="leading-relaxed">
              Lextria Research may amend this Privacy Policy periodically.
              Changes will be communicated via our website at least ten (10)
              days before implementation. By continuing to use the Website after
              changes are posted, you agree to the revised Privacy Policy.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Governing Law and Dispute Resolution
            </h3>
            <p className="leading-relaxed">
              This Privacy Policy shall be governed by the laws of India. Any
              disputes will be resolved through arbitration in Udupi, Karnataka,
              conducted in English under the Arbitration & Conciliation Act,
              1996.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Your Consent
            </h3>
            <p className="leading-relaxed">
              By using the Website and providing your information, you consent
              to the collection, use, and disclosure of your information as per
              this Privacy Policy.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Contacting the Firm
            </h3>
            <p className="leading-relaxed">
              For questions about this Privacy Policy, contact us at
              <a
                href="mailto:info@lextria.in"
                className="text-blue-600 hover:text-blue-800 hover:underline ml-1"
              >
                info@lextria.in
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
